<template>
  <div class="StaffTableBox">
    <div class="title">
      <img class="titleIcon" src="@/assets/images/xinyulou/icon_4.png" alt />
      <span>门店数据</span>
    </div>
    <screenForm @dataFilter="datafilter" />

    <GlobalTable
      ref="GlobalTable"
      v-loading="tableLoading"
      :columns="tableColumns"
      :data="tableData"
      :currentPage="page.pageNum"
      :total="pageTotal"
      :isIndex="false"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column align="center" width="130" slot="sort" label="序号">
        <template slot-scope="{ row }">
          <div class="flex">
            <div>{{ row.sort }}</div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.tipText"
              placement="top"
              v-if="row.tipText"
            >
              <img
                class="tipsIcon"
                src="@/assets/images/xinyulou/tip_icon.png"
              />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </GlobalTable>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import { MessageBox } from "element-ui";

import screenForm from "./tableForm.vue";

import { _http } from "@/utils/request/storeStatistics";
export default {
  components: {
    screenForm,
  },

  data() {
    return {
      tableLoading: true,
      // 表格数据
      tableData: [],
      tableColumns: [
        { slotName: "sort" },
        { prop: "companyName", label: "项目部", width: "120" },
        { prop: "areaName", label: "门店", width: "120" },
        { prop: "storeName", label: "柜组", width: "120" },
        { prop: "tagName", label: "柜组标签", width: "100" },
        { prop: "inquiryNum", label: "询价量(次)", width: "120" },
        { prop: "avgFinalPrice", label: "顾客成交单价(元)", width: "120" },
        { prop: "dealCount", label: "回收量(个)", width: "120" },
        { prop: "dealPrice", label: "回收金额(元)", width: "120" },
        { prop: "delayAddPrice", label: "事业部返佣(元)", width: "120" },
        { prop: "storeAddPrice", label: "预留返佣(元)", width: "120" },
      ],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,

      filterData: {},
    };
  },
  created() {
    // this.getTableData();
  },
  methods: {
    getTableData() {
      this.tableLoading = true;
      const resDt = {
        // startTime: "",
        // endTime: "",

        // areaId: 0,
        // companyId: 0,
        inspectorId: 0,
        // storeId: 0,
        // tagId: 0,
        ...this.filterData,
        ...this.page,
      };
      _http
        .storeStatisticsData(resDt)
        .then((res) => {
          const list = [];
          if (res.code === 1) {
            const pageData = res.data.page;

            // 第一页第一行需要显示总计数据
            if (resDt.pageNum === 1) {
              delete res.data.page;
              list.push({
                ...res.data,
                sort: "总计",
                companyName: "--",
                areaName: "--",
                storeName: "--",
                tagName: "--",
              });

              // 新增总计2
              if (res.data.summary) {
                list.push({
                  ...res.data.summary,
                  tipText: "项目部下的门店的创建人、子账号、总监的数据统计",
                  sort: "创建人、子账号、总监",
                  companyName: "--",
                  areaName: "--",
                  storeName: "--",
                  tagName: "--",
                });
              }
            }

            if (pageData) {
              list.push(
                ...(pageData.records || []).map((r, i) => {
                  return {
                    sort: (resDt.pageNum - 1) * resDt.pageSize + i + 1, // 序号需要自定义下
                    ...r,
                  };
                }),
              );
              this.pageTotal = pageData.total || 0;
            }
          }
          this.tableData = list;
        })
        .finally(() => (this.tableLoading = false));
    },

    // 表格进行分页
    handleCurrentChange(page) {
      this.page.pageNum = page;
      this.getTableData();
    },
    datafilter(data) {
      this.page.pageNum = 1;
      this.filterData = data;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>

.flex{
  display: flex;
  align-items: center;
  justify-content: center;
}
.StaffTableBox {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px 0 0;
  > .title {
    padding: 0 20px 20px;
    > span {
      font-family: PingFangSC, PingFang SC;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      vertical-align: middle;
    }
  }

  /deep/ .el-table-container {
    padding: 0 20px;
  }
}
</style>
